var preWindows = document.querySelectorAll('pre');
preWindows.forEach(preWindow => {
    const buttonElement = document.createElement('button');
    buttonElement.textContent = "Copy";
    buttonElement.className = "btn btn-sm btn-soft-primary";
    buttonElement.style.position = "absolute";
    buttonElement.style.top = "6rem";
    buttonElement.style.right = "1rem";

    buttonElement.onclick = function() {
        CopyCode(preWindow, buttonElement);
    };

    preWindow.insertBefore(buttonElement, preWindow.firstChild);
});

function CopyCode(code, button){
    const codeWindows = code.querySelectorAll('code');
    let FullCode = '';
    codeWindows.forEach(codeWindow => {
        FullCode += codeWindow.textContent;
    });
    button.textContent = "Copied !";
    navigator.clipboard.writeText(FullCode);
    setTimeout(function() {
        button.textContent = "Copy";
    }, 2000);
}